import { render, staticRenderFns } from "./CommentReferenceWidget.vue?vue&type=template&id=783e94ac&scoped=true&"
import script from "./CommentReferenceWidget.vue?vue&type=script&lang=js&"
export * from "./CommentReferenceWidget.vue?vue&type=script&lang=js&"
import style0 from "./CommentReferenceWidget.vue?vue&type=style&index=0&id=783e94ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e94ac",
  null
  
)

export default component.exports